export default "__VITE_ASSET__DgRtL57t__"